var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"loadingMain"})}
var staticRenderFns = []

export { render, staticRenderFns }